import { tk as baseTk, type Locale, type TkOptions } from '@sabay/i18n';
import { createContext, useContext, useMemo } from 'react';

export const LocaleContext = createContext<Locale>('zh-CN');

export function useLocale(): Locale {
  return useContext(LocaleContext);
}

/** 组件内 i18n helper：自动注入当前 locale，无需每次传 options.locale */
export function useTk(): (key: string, options?: Omit<TkOptions, 'locale'>) => string {
  const locale = useLocale();
  return useMemo(
    () => (key: string, options?: Omit<TkOptions, 'locale'>) => baseTk(key, { ...options, locale }),
    [locale],
  );
}
